<template>

    <select v-model="handler" class="form-control" @change="change">
        <option v-for="option in options" :value="option">{{option}}</option>
        <option v-if="!options.includes(handler)" :value="handler">{{handler}}</option>
    </select>

</template>

<script>

export default {
  props: ['config', 'name', 'value'],
  data(){
      return {
          handler:'normal',
      }
  },
  computed:{
  	fonts(){
  		return this.$store.getters.fonts
  	},
  	options(){
  		var def = ['400','700'];
  		var fontFamily = window.blockObj.data.fontFamily;
  		if(!fontFamily || !this.fonts) return def;

  		if(fontFamily=='inherit') fontFamily = this.$store.getters.project.meta.defaultFont;

  		var font = this.fonts.find(gfont => gfont.family==fontFamily);
  		if(!font) return def;

  		var options = [];
  		font.variants.forEach(variant=>{
  			if(variant=='regular') options.push('400');
  			if(variant.match(/^\d+$/)) options.push(variant);
  		});
  		if(!options) return def;
  		return options;
  	}
  },
  mounted(){
    this.handler = this.value
  },
  methods:{
    change(){
        var newval = this.handler;
        this.$emit('change',newval);
    },

  }

}
</script>
